import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: [],
    segment: [],
  },
  getters: {
    list: (state) => state.list.filter((x) => !x.isDeleted),
    segment: (state) => state.segment,
    listWithShelves: (state) =>
      state.list.filter(
        (x) => !x.isDeleted && x.shelveQueries && x.shelveQueries.length > 0
      ),
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax.get("WarehousingManagement/api/WarehouseQuery");
    },
    fetchList({ commit, dispatch }) {
      return ajax.get("WarehousingManagement/api/WarehouseQuery").then((r) => {
        commit("setList", r.data.data);
      });
    },

    fetchListWithNOTakeSkip({ commit, dispatch }) {
      return ajax
        .get("WarehousingManagement/api/WarehouseQuery?Take=100&Skip=0")
        .then((r) => {
          commit("setList", r.data.data);
        });
    },
    
    fetchSegment({ commit }) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Inventory/api/SegmentQuery/all-tiny-info")
          .then((r) => {
            commit("setSegment", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    fetchSingle({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("WarehousingManagement/api/WarehouseQuery/" + id)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    create({ commit, dispatch }, model) {
      return ajax
        .post("WarehousingManagement/api/Warehouses", model)
        .then(() => {
          //dispatch('fetch')
        });
    },
    remove({ commit, dispatch }, id) {
      return ajax
        .delete(
          "WarehousingManagement/api/Warehouses",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {
          //dispatch('fetch')
        });
    },
    update({ commit, dispatch }, model) {
      return ajax
        .put("WarehousingManagement/api/Warehouses", model)
        .then(() => {
          //dispatch('fetch')
        });
    },

    ////shelve
    createShelve({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("WarehousingManagement/api/shelves", model)
          .then(() => {
            dispatch("fetchSingle", model.warehouseId)
              .then((warehouse) => {
                resolve(warehouse);
              })
              .catch((e) => reject(e));
          })
          .catch((e) => reject(e));
      });
    },
    removeShelve({ commit, dispatch }, { shelveId, warehouseId }) {
      return new Promise((resolve, reject) => {
        ajax
          .delete(
            "WarehousingManagement/api/Shelves",
            { data: { shelveId: shelveId, warehouseId: warehouseId } },
            { headers: { "Content-Type": "application/json" } }
          )
          .then(() => {
            dispatch("fetchSingle", warehouseId)
              .then((warehouse) => {
                resolve(warehouse);
              })
              .catch((e) => reject(e));
          })
          .catch((e) => reject(e));
      });
    },
    updateShelve({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("WarehousingManagement/api/shelves", model)
          .then(() => {
            dispatch("fetchSingle", model.warehouseId)
              .then((warehouse) => {
                resolve(warehouse);
              })
              .catch((e) => reject(e));
          })
          .catch((e) => reject(e));
      });
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    },
    setSegment(state, data) {
      state.segment = data;
    },
  },
};
